import { type IDecodedToken } from "@interfaces/auth/IDecodedToken";
import { jwtDecode } from "jwt-decode";

export class TokenUtils {
  private readonly decodedToken: IDecodedToken;

  constructor(accessToken: string) {
    this.decodedToken = jwtDecode<IDecodedToken>(accessToken);
  }

  getUserTenants(): string[] {
    return this.decodedToken["oct-tenants"];
  }

  getUserAdmin(): string[] {
    return this.decodedToken.admin ?? [];
  }

  getUserRut(): string {
    return this.decodedToken.preferred_username;
  }

  getUserEmail(): string {
    return this.decodedToken.email;
  }

  getUserFirstName(): string {
    return this.decodedToken.given_name;
  }

  getUserLastName(): string {
    return this.decodedToken.family_name;
  }

  getUserFullName(): string {
    return this.decodedToken.name;
  }

  getUserTenantsIds(): Record<string, number> {
    return this.decodedToken.oct_tenants_ids;
  }
}
